import React from "react";
import Hero from './GISSurvey/Hero';
import MagicBento from './GISSurvey/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const GISSurvey = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default GISSurvey;
